"use strict";
(function (global) {

  /** 
  * Ссылки.

  * @class WebAccess.URL
  * @param {String|WA.Link} url Адрес URL, либо ссылка WA.Link на объект системы.
  * @property {String} className Имя класса  
  * @property {integer} id ИД объекта
  * @since 5.0.0.7300
  */
  var URL = Class.extend({
    className: "URL",
    _url: '',

    init: function (url) {
      if (typeof url === 'object' && url.className === 'Link') {
        this._url = this._getUrlFromLink(url);
      } else {
        this._url = url;
      }
      if (!url) this._url = window.location.href;
      this._refresh();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//    

    /**
    * todo, может когда нибудь в будущем
    * @ignore
    */
    _refresh: function () {
      return;
      //$.extend(this, new window.URL(this._url));
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Открывает URL-ссылку в новом окне.
     * Примечание. Браузер Google Chrome блокирует страницы, которые открываются через асинхронный вызов или из потока, 
     * не имеющего прямого участия с пользователем. Для устранения этой ситуации, используйте пример, представленный ниже.
     *
     * @method WebAccess.URL#open
     * @since 5.0.0.7300
     * @return {WebAccess.current.window} Объект типа window.
     *
     * @example <caption>Открытие ссылки в новом окне</caption>
     * var url = new WA.URL('/Explorer.aspx');
     * url.open();
     *
     * @example <caption>Асинхронное открытие объектов</caption>
     * function createTask() {
     *   var taskTab = new WA.URL('/PleaseWait.aspx').open(); // Ссылка на указанную веб-страницу открывается.
     *   WebAccess.factories.tasks.createTask().done(function(task) {
     *     // Если здесь вызвать task.toURL().open(), то в браузере Google Crome появится уведомление, что всплывающее окно заблокировано.
     *     task.toURL().openIn(taskTab);
     *     // Второй вариант: taskTab.location.href = task.toURL();
     *   });
     * };
     */
    open: function (opt_target) {
      opt_target = opt_target || '_blank';
      return window.open(this._url, opt_target);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Открывает URL-ссылку в указанном окне.
    *
    * @method WebAccess.URL#openIn
    * @param {window} window Окно браузера, в котором необходимо открыть URL-ссылку
    * @return {WebAccess.current.window} Объект типа window.
    * @since 5.0.0.7300
    */
    openIn: function (win) {
      return win.location.href = this._url;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает параметр URL-ссылки.
    *
    * @method WebAccess.URL#getParam
    * @param {String} paramName Имя параметра
    * @return {String} Наименование параметра URL-ссылки.
    * @since 5.0.0.7300
    */
    getParam: function (paramName) {
      return this._getParam(paramName, this.asStringWithoutHash());
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить параметр из URL.
    *
    * @method WebAccess.URL#getParam
    * @param {String} paramName Имя параметра
    * @since 5.0.0.7300
    * @return {String}
    * @private
    */
    _getParam: function (paramName, url) {
      var param = this._getNonEncoded(url, paramName);
      try {
        return decodeURIComponent(param);
      } catch (_) {
        return param;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает параметр из хеша URL-ссылки.
    *
    * @method WebAccess.URL#getParamInHash
    * @param {String} paramName Имя параметра
    * @since 5.0.0.7300
    * @return {String} Наименование параметра, полученного из хеша URL-ссылки.
    */
    getParamInHash: function (paramName) {
      return this._getParam(paramName, '?' + this.getHash());
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создает или изменяет параметр из хеша URL-ссылки.
    *
    * @method WebAccess.URL#getParamInHash
    * @param {String} paramName Имя параметра
    * @since 5.2.0.1100
    * @return {String} Наименование параметра, полученного из хеша URL-ссылки.
    */
    setParamInHash: function (paramName, value) {
      var me = this;
      var newHash = me._setParam(paramName, value, '?' + me.getHash()).substr(1);
      if (newHash.charAt(0) === '&') newHash = newHash.substr(1); //Удаляем лишний & вначале
      me._url = me.asStringWithoutHash() + '#' + newHash;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает хеш URL-ссылки.
    *
    * @method WebAccess.URL#getHash
    * @since 5.0.0.7300
    * @return {String} Строга, содержащая хеш URL-ссылки.
    */
    getHash: function () {
      var hashIndex = this._url.indexOf('#');
      if (hashIndex != -1) {
        return this._url.substr(hashIndex + 1);
      } else {
        return "";
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает расширение файла.
    * @method WebAccess.URL#getExtension
    * @since 5.2.0.1100
    * @return {String}
    */
    getExtension: function () {
      return WA._getFileExtensionFromURL(this._url);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает строку URL-ссылки без хэш-символов.
    * @method WebAccess.URL#asStringWithoutHash
    * @since 5.0.0.7300
    * @return {String} Строка URL-ссылки без хэш-символов.
    */
    asStringWithoutHash: function () {
      var hashIndex = this._url.indexOf('#');
      if (hashIndex != -1) {
        return this._url.substr(0, hashIndex);
      } else {
        return this._url;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создает или изменяет параметр URL-ссылки.
    *
    * @method WebAccess.URL#setParam
    * @param {String} paramName Имя параметра
    * @param {String} value Новое значение, заданное параметру
    * @return {WebAccess.URL} Объект типа URL.
    * @since 5.0.0.7300
    */
    setParam: function (paramName, value) {
      var hash = this.getHash(this._url);

      this._url = this._setParam(paramName, value, this.asStringWithoutHash());
      if (hash)
        this._url = this._url + '#' + hash;

      this._refresh();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создает или изменяет параметр URL-ссылки.
    *
    * @method WebAccess.URL#setParam
    * @param {String} paramName Имя параметра
    * @param {String} value Новое значение, заданное параметру
    * @param {String} url URL-ссылка.
    * @return {WebAccess.URL} Объект типа URL.
    * @since 5.2.0.1100
    * @private
    */
    _setParam: function (paramName, value, url) {
      var newUrl = url;
      var re = new RegExp('([\?|&])' + paramName + '=([^?&]*)', 'i');
      var m = re.exec(newUrl);
      if (!m) {
        newUrl += ((newUrl.indexOf('?') == -1) ? '?' : '&') + paramName + "=" + encodeURIComponent(value);
      } else {
        newUrl = newUrl.replace(re, m[1] + paramName + "=" + encodeURIComponent(value));
      }
      return newUrl;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Удаляет параметр из URL-ссылки.
    *
    * @method WebAccess.URL#removeParam
    * @param {String} paramName Имя параметра
    * @since 5.0.0.7300
    * @return {WebAccess.URL} Объект типа URL.
    */
    removeParam: function (paramName) {
      var me = this;
      var hash = me.getHash(me._url);
      var urlWithoutHash = me.asStringWithoutHash();
      var re = new RegExp('([\?|&]?)' + paramName + '=([^?&]*)', 'ig');
      urlWithoutHash = urlWithoutHash.replace(re, "$1").replace('?&', '?').replace('&&', '&');
      if (urlWithoutHash.charAt(urlWithoutHash.length - 1) === '&') {
        urlWithoutHash = urlWithoutHash.substr(0, urlWithoutHash.length - 1);
      }
      if (hash) {
        me._url = urlWithoutHash + '#' + hash;
      } else {
        me._url = urlWithoutHash;
      }
      me._refresh();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение не закодированного URL
    * @method WebAccess.URL#_getNonEncoded
    * @private
    * @since 5.0.0.7300
    * @return {String}
    */
    _getNonEncoded: function (url, name) {
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS, 'i');
      var results = null;
      if (!url) {
        results = regex.exec(window.location.href);
      } else {
        results = regex.exec(url);
      }
      if (!results) {
        return "";
      } else {
        return results[1];
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обработка объекта Link - выжимка и сборка из него url
    * @method WebAccess.URL._getUrlFromLink
    * @private
    * @return {String} строка url
    * @since 5.0.0.7300
    */
    _getUrlFromLink: function (link) {
      var host = window.location.href.substr(0, window.location.href.lastIndexOf('/') + 1);
      var page = this._getPageNameByKind(objectTypeToString(link.type));
      var url = host + page + "x?sys=" + g_SysCode +
                "&id=" + link.id +
                (link.referenceName ? "&compcode=" + encodeURIComponent(link.referenceName) : '') +
                "&ext=" + g_ExtName;
      return url;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение имени страницы исходя из типа объекта.
    * @method WebAccess.URL._getPageNameByKind
    * @param {String} kind
    * @private
    * @return {String}
    * @since 5.0.0.7300
    */
    _getPageNameByKind: function (kind) {
      switch (kind.toUpperCase()) {
        case "EDOC": return "doc.asp";
        case "FOL": return "folder.asp";
        case "JOB": return "job.asp";
        case "TASK": return "task.asp";
        case "REF": return "reference.asp";
        default:
          return null;
          break;
      }
      return null;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает строкове представление адреса URL-ссылки.
    *
    * @method WebAccess.URL#asString
    * @since 5.0.0.7300
    * @return {String} Строка с адресом URL-ссылки.
    */
    asString: function () {
      return this._url;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  global.URL = URL;
})(window.WebAccess);